 <template>
	<el-dialog title="公司编辑" top="1vh" width="1080px" :visible.sync="is_show_in_page" @close="shipper_close">
		
		<!-- 表单 -->
		<el-form label-width="130px" style="margin:-15px 0 20px 0">
			<div class="big_tit" style="margin:0">基本信息</div>

			<div class="tab1_inner">
				<el-form-item  class="el_form_item" label="企业类型" label-width="150px">
					<el-input v-model="enterpriseType">
					
					</el-input>
				</el-form-item>
				<el-form-item  class="el_form_item" label="注册资本（万元）" label-width="200px">
					<el-input v-model="registeredCapital">
					
					</el-input>
				</el-form-item>
			</div>
			<div class="tab1_inner">
				<el-form-item  class="el_form_item" label="经营范围" label-width="150px">
					<el-input v-model="businessScope">
					</el-input>
				</el-form-item>

                <el-form-item class="el_form_item" label="身份证有效期起" label-width="185px">
				    <el-date-picker style="width: 265px" v-model="time.periodValidity" type="date" placeholder="选择日期" value-format="timestamp"></el-date-picker>
				</el-form-item>
			</div>
            <div class="tab1_inner">
				<el-form-item  class="el_form_item" label="联系人姓名" label-width="150px">
					<el-input v-model="contactName">
					</el-input>
				</el-form-item>
				<el-form-item  class="contactEmail" label="联系人邮箱" label-width="158px">
					<el-input v-model="contactEmail">
					</el-input>
				</el-form-item>
			</div>
			<div class="big_tit" style="margin:0">印章图片</div>
			<div class="tab1_inner">
					<div class="el_form_item" style="width:48%;margin-left:1%">
					<div class="img_btn">
						<div v-if="!partyASignImg_src" class="btn">未上传</div>
						  <el-image
								v-else
								class="img"
								:src="partyASignImg_src"
								:previewSrcList="partyASignImg_src_list"
								:z-index = 3000
								>
							</el-image>
					</div>
					<div class="bottom_text">印章图片
						<el-button class="btn_left" size="mini" type="text" @click="voucher_add()">上传</el-button>
					</div>
				</div>
			</div>
		</el-form>

		<div class="bottom_btns">
			<el-button type="primary" @click="edit_sub()">提交</el-button>
		</div>
		<!-- 凭证添加界面 -->
		<el-dialog
			title="证件上传"
			top="2vh"
			width="500px"
			:visible.sync="upl.is_show"
			:modal="false"
			>
			<div class="upl">
				<div class="img_area" @click="voucher_add_sub">
				<img v-if="upl.src" :src="upl.src" class="show" />
				<i v-else class="el-icon-plus avatar-uploader-icon icon"></i>
				</div>

				<div class="btn_area">
				<el-button type="primary" @click="voucher_sub()">上传</el-button>
				</div>
			</div>
		</el-dialog>
	</el-dialog>
	
</template>

<script>
	export default {
		components:{
		},
		props:{
			is_show:Number,
			data:''
		},
		data() {
			return {

				//是否显示
				is_show_in_page:false,

				//上传界面
				upl: {
					//是否显示上传界面
					is_show: false,

					//地址
					src: "",
				},
                id:'',
                enterpriseType:'',//企业类型
                registeredCapital:'',//注册资本（万元）
                periodValidity:'',//营业执照有效期至
                businessScope:'',//经营范围
                contactEmail:'',//联系人邮箱
                contactName:'',//联系人姓名
                partyASignImg:'',//印章

                partyASignImg_src:'',
                partyASignImg_src_list:[],
                time:{
                    periodValidity:'',
                }
			}
		},
		watch:{
			is_show(new_data){
				if(new_data){
                    this.init(this.data)
					//打开弹出层
					this.is_show_in_page=true;

				}else{

					//关闭弹出层
					this.is_show_in_page=false;
				}
			},
		},
		methods: {
            shipper_close(){
                this.time={
                    periodValidity:'',
                }
                
                this.partyASignImg_src='',
                this.partyASignImg_src_list=[]
                this.id='',
                this.enterpriseType='',//企业类型
                this.registeredCapital='',//注册资本（万元）
                this.periodValidity='',//营业执照有效期至
                this.businessScope='',//经营范围
                this.contactEmail='',//联系人邮箱
                this.contactName='',//联系人姓名
                this.partyASignImg=''//印章
            },
			voucher_add() {
				//打开添加凭证界面

				//打开上传界面
				this.upl.is_show = true;

				//清空上次上传的图片
				this.upl.src = "";
			},
			voucher_add_sub() {
				//提交凭证

				//选择图片
				this.$my.qiniu.choose_img({
					success: (res) => {
					//预览
					this.upl.src = res.src;
					},
				});
			},
			voucher_sub() {
				//上传
				this.$my.qiniu.upl({
					bucket: "driversourceproof",
					file_path: this.upl.src,
					callback: (data) => {
				     	var key = data.key.split('__v__1')
						this.partyASignImg = key[0]
						this.partyASignImg_src = this.upl.src
					    this.partyASignImg_src_list = [this.upl.src];
						this.upl.is_show = false;
					},
				});
			},
			edit_sub(){
				//表单
				let form={
					mod:'app_user',
					ctr:'company_edit_admin',
					id:this.id,
					enterpriseType:this.enterpriseType,
					registeredCapital:this.registeredCapital,
					periodValidity:Number(this.time.periodValidity) /1000,
					businessScope:this.businessScope,
					contactName:this.contactName,
					contactEmail:this.contactEmail,
					partyASignImg:this.partyASignImg,
				}
				
				//提交数据
				this.$my.net.req({
					data:form,
					callback:(data)=>{
						this.$my.other.msg({
							type:'success',
							str:'修改成功'
						});
						this.is_show_in_page=false;
						this.$emit('success')
					},
				});
			},
            //初始化
            init(item){
                this.id=item.id
                this.enterpriseType = item.enterpriseType
                this.registeredCapital = item.registeredCapital
                this.businessScope = item.businessScope
                this.contactName = item.contactName
                this.contactEmail= item.contactEmail	
                if(item.partyASignImg){
                    this.partyASignImg	 = item.partyASignImg
                    this.partyASignImg_src	 = this.$my.qiniu.make_src('drivercy',item.partyASignImg)
                    this.partyASignImg_src_list[0]	 = this.$my.qiniu.make_src('drivercy',item.partyASignImg)
                }
                if(item.periodValidity!=0){
                     this.periodValidity = item.periodValidity
                     this.time.periodValidity = Number(item.periodValidity) *1000
                }else{
                    this.periodValidity = ''
                }
            },
		}
	}
</script>
<style lang="scss" scoped>
.upl {
  .img_area {
    border: 1px solid #ccc;
    cursor: pointer;
    padding: 5px;
    .show {
      margin: auto;
      display: block;
      max-width: 100%;
      max-height: 100%;
    }
    .icon {
      text-align: center;
      display: block;
      font-size: 100px;
      height: 500px;
      line-height: 500px;
    }
  }
  .mark_area {
    border: 1px solid #ccc;
    padding: 5px;
    width: 448px;
    margin-top: 10px;
    height: 100px;
    outline: none;
    font-size: 16px;
  }
  .mark_area::placeholder {
    font-size: 20px;
    line-height: 100px;
    text-align: center;
  }
  .btn_area {
    text-align: center;
    margin-top: 15px;
  }
}
	.el_form_item {
		margin: 0;
		.img_btn {
			border: 1px solid #bbb;
			border-radius: 5px;
			cursor: pointer;
			padding: 5px;
			height: 300px;
			overflow: hidden;
			.btn {
			text-align: center;
			line-height: 290px;
			font-size: 14px;
			}

			.img {
			position: relative;
			display: block;
			height: 290px;
			}
		}
		  .bottom_text {
			margin-top: 5px;
			text-align: center;
		}
	}
	
	.big_tit{
		background-color: #eee;
		padding: 10px 20px;
		color: #666;
		font-weight: 600;
		font-size: 18px;
		margin-top: 20px;
	}
	.tab1_inner{
		padding: 15px 15px 0 15px;
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	.el_inner_width{
		width:94%;
	}
	.tord_real_time_add_bottom_btns{
		margin-top: 40px;
		text-align: center;
	}
	.bottom_btns{
		text-align: center;
		margin-top: 30px;
	}
	.el-dialog-s{
		z-index: 11;
	}
	.company_contract{
		display: flex;
		justify-content: space-around;
	}
	#pdf_upload{
		margin-right: 100%;
	}
</style>